import {Configuration, ResourceApi} from "@casablanca/casablanca.contracts.iam-client-ts-v1"
import authenticatedFetch from "../authenticatedFetch"
import { env } from '../../environment';

export default new ResourceApi(new Configuration({
    basePath: env.IAM_API_BASE_URL,
    fetchApi: authenticatedFetch,
}))
